import * as React from 'react';
import './Wave.scss';
import { AudioInterface } from '../../utils/AudioInterface';

interface Props {
  audioInterface?: AudioInterface;
  color?: string;
  duration?: number;
  waveformCoordinates: number[][];
}

/**
 * WaveBars - Waveform made of horizontal bars.
 *
 * @export
 * @class WaveBars
 * @extends {React.Component<IProps, IState>}
 */
export class WaveBars extends React.Component<Props> {
  props: Props;
  private animationFrameID: number;
  private lineElements?: SVGLineElement[];
  private svgRef = React.createRef<SVGSVGElement>();

  componentDidMount() {
    if (!this.svgRef.current) {
      return;
    }

    const animateFrame = () => {
      if (!this.lineElements) {
        this.lineElements = Array.from(this.svgRef.current.querySelectorAll('line'));
      }
      const time = this.props.audioInterface
        ? this.props.audioInterface.currentTime / this.props.duration / 10
        : 0;

      this.lineElements.forEach(line => {
        const x1 = Number(line.getAttribute('x1'));
        line.style.stroke = x1 < time * 1.1 ? this.props.color : null;
      });
      this.animationFrameID = requestAnimationFrame(animateFrame);
    };
    this.animationFrameID = requestAnimationFrame(animateFrame);
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.animationFrameID);
  }

  render() {
    return (
      <div className="waveform">
        <svg
          height="100%"
          preserveAspectRatio="none"
          width="100%"
          viewBox="0 0 100 2"
          ref={this.svgRef}
        >
          {this.props.waveformCoordinates.map((coordinate, index) => {
            const height = Math.max(coordinate[1], 0.2);
            return (
              <line
                key={`bar-${index}(${coordinate[0]},${coordinate[1]})`}
                x1={coordinate[0]}
                x2={coordinate[0]}
                y1={0}
                y2={height}
                strokeWidth="1"
                transform={`translate(0, ${(2 - height) / 2})`}
                vectorEffect="non-scaling-stroke"
              />
            );
          })}
        </svg>
      </div>
    );
  }
}
